export const orderMap = {
  index: {
    title: '주문관리',
    path: '/orders',
    display: true,
  },
  integratedOrder: {
    title: '주문통합검색',
    path: '/orders/integrated',
    display: true,
  },
  duplicatedOrder: {
    title: '중복 주문 목록',
    path: '/orders/duplicated',
    display: true,
  },
  'payment-pending': {
    title: '결제 대기 확인',
    path: '/orders/outstanding',
    display: true,
  },
  'payment-done': {
    title: '상품 준비중 관리',
    path: '/orders/received',
    display: true,
  },
  'discount-offer': {
    title: '상품 준비중 관리\n(할인 요청)',
    path: '/orders/discount-offer',
    display: true,
  },
  'shipping-pending': {
    title: '배송 준비중 관리',
    path: '/orders/processed',
    display: true,
  },
  'shipping-in-progress': {
    title: '배송중 관리',
    path: '/orders/in-delivery',
    display: true,
  },
  'shipping-done': {
    title: '배송 완료 관리',
    path: '/orders/completed',
    display: true,
  },
  'purchase-done': {
    title: '구매 확정 내역',
    path: '/orders/confirmed',
    display: true,
  },
};
